import { z } from 'zod';

// État du frontend stable de dev (stable.<domaine>), écrit par le script de rafraîchissement de la
// factory dans <frontend>/.stable/status.json et lu par le bouton « Recompiler » de dev.
// `requested` : une demande attend que la machine la prenne ; `unknown` : aucun état écrit.
export const stableBuildStateSchema = z.enum([
  'ready',
  'building',
  'failed',
  'requested',
  'unknown',
]);

export const stableBuildStatusSchema = z.object({
  state: stableBuildStateSchema,
  /** Dernier commit d'integration vu par le script. */
  integration: z.string().nullable(),
  /** Commit servi par le conteneur stable. */
  served: z.string().nullable(),
  /** Date de l'état, ISO. */
  at: z.string().nullable(),
});

export const stableBuildResponseSchema = z.discriminatedUnion('ok', [
  z.object({ ok: z.literal(true), status: stableBuildStatusSchema }),
  z.object({ ok: z.literal(false), messageKey: z.string() }),
]);

export type StableBuildState = z.infer<typeof stableBuildStateSchema>;
export type StableBuildStatus = z.infer<typeof stableBuildStatusSchema>;
export type StableBuildResponse = z.infer<typeof stableBuildResponseSchema>;
